import React from 'react'
import { useController } from 'react-hook-form'
import CaluRawInput from '@/components/styledComponents/CaluRawInput'
import { parsedDniValue } from '@/utils/functions/parsedDniValue'

import PropTypes from 'prop-types'

const CaluFormInput = ({ name, multiline = false, maxRows = 15, helperText, ...props }) => {
  const {
    field: { onChange, onBlur, value },
    fieldState: { error },
  } = useController({ name })

  const isError = Boolean(error?.message)
  const inputHelperText = isError ? error.message : helperText
  const parsedValue = name === 'dni' ? parsedDniValue(value) : value || ''

  return (
    <CaluRawInput
      {...props}
      error={isError}
      helperText={inputHelperText}
      onChange={onChange}
      onBlur={onBlur}
      value={parsedValue}
      multiline={multiline}
      id={name}
      maxRows={maxRows}
    />
  )
}

export default CaluFormInput

CaluFormInput.propTypes = {
  name: PropTypes.string.isRequired,
  multiline: PropTypes.bool,
  maxRows: PropTypes.number,
  helperText: PropTypes.string,
  helperTextClassName: PropTypes.string,
}
